import { FC } from 'react';
import { useRoutes } from 'react-router-dom';

import MissionManager from '../pages/MissionManager';
import MissionPlanner from '../pages/MissionPlanner';
import FlightOps from './pages/FlightOps';
import PilotProtectedRoute from './PilotProtectedRoute';

export const pilotRoutes = [
  {
    path: '/pilot',
    element: <PilotProtectedRoute />,
    children: [
      {
        path: 'fly-now/ops',
        element: <FlightOps />
      },
      {
        path: 'planning',
        element: <MissionPlanner />
      },
      {
        path: 'mission-manager',
        element: <MissionManager />
      }
    ]
  }
];

const PilotRoutes: FC = () => {
  const routing = useRoutes(pilotRoutes);
  return routing;
};

export default PilotRoutes;
